module.exports = __webpack_public_path__ + "img/matrix.efe18d93.png";